import React, { useEffect, useState } from "react";
import {
  MDBBadge,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCol,
  MDBCardFooter,
  MDBBtn,
} from "mdbreact";
import { url } from "api";
import formatTime from "helpers/formatTime";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import DefaultImage from "assets/images/Default_Brand_Image.png";
import { useHistory } from "react-router";

const BrandItemMainAdmin = (props) => {
  const { img, name, description, date, users, _id, posts, zipInfo, company } =
    props.brandItem;
  const { parentBrandID, isParent } = props;

  const [brandPicture, setBrandPicture] = useState(null);

  const { userWhoCreate } = props;
  const history = useHistory();

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (img?.split(".").pop() === "gz") {
        const extractedImg = await extractImageFromZip(img);
        if (isMounted) {
          setBrandPicture(extractedImg);
        }
      } else {
        if (isMounted) {
          setBrandPicture(DefaultImage);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [img, props.brandItem]);

  return (
    <MDBCol className={`${props.className} h-auto`}>
      <MDBCard className="h-100">
        <div className="brand-item-img">
          <img
            src={brandPicture}
            alt={`Brand ${name}`}
            onError={(e) => (e.target.src = DefaultImage)}
          />
          <span className="brand-item-date">{formatTime(date)}</span>
        </div>
        <MDBCardBody>
          <MDBCardTitle className="font-size-2">{name}</MDBCardTitle>
          <MDBCardText
            tag="div"
            className="d-flex flex-column align-items-start"
          >
            <p>{description}</p>
            {users.length === 0 ? (
              <h6>
                <MDBBadge pill tag="span" color="danger">
                  Deleted
                </MDBBadge>
              </h6>
            ) : null}
            <span>
              User: {userWhoCreate?.name} {userWhoCreate?.lastName}
            </span>
            <span>Email: {userWhoCreate?.email}</span>
          </MDBCardText>
        </MDBCardBody>
        <MDBCardFooter className="pl-2 pr-2 pb-2 pt-0">
          <div className="d-flex align-items-center  justify-content-between">
            <MDBBtn
              color=""
              className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit"
              onClick={() => {
                props.openMembersModal();
              }}
            >
              Members
            </MDBBtn>

            <MDBBtn
              color=""
              className="bg-bid btnFlex text-white border-bid shadow-none text-style-inherit "
              onClick={() => {
                history.push(`/personal-area/brands/${_id}/posts`);
              }}
            >
              Posts ({posts?.length})
            </MDBBtn>
          </div>
        </MDBCardFooter>
      </MDBCard>
    </MDBCol>
  );
};

export default BrandItemMainAdmin;
